// Company Information
export const COMPANY = {
  name: 'SEVENHC',
  phone: '+94 77 23 53 975',
  email: 'info@sevenhc.net',
  domain: 'sevenhc.net',
  url: 'https://sevenhc.net',
};

// Services Data
export const SERVICES = [
  {
    id: 'custom-software',
    title: 'Custom Software Solutions',
    description: 'Enterprise-grade applications, mobile apps, and system integrations built to scale with your business.',
    icon: 'code',
    technologies: ['React', 'Node.js', 'Python', '.NET', 'Java', 'Flutter'],
    link: '/services#custom-software',
  },
  {
    id: 'web-development',
    title: 'Website & Web App Development',
    description: 'Modern, responsive websites and powerful web applications designed for performance and user experience.',
    icon: 'monitor',
    technologies: ['React', 'Next.js', 'Vue.js', 'WordPress', 'Shopify'],
    link: '/services#web-development',
  },
  {
    id: 'data-analytics',
    title: 'Data Analytics & Business Intelligence',
    description: 'Transform raw data into actionable insights with custom dashboards, reports, and predictive analytics.',
    icon: 'trending-up',
    technologies: ['Power BI', 'Tableau', 'Python', 'SQL', 'Machine Learning'],
    link: '/services#data-analytics',
  },
  {
    id: 'sharepoint',
    title: 'SharePoint Development & Support',
    description: 'Custom SharePoint solutions, workflows, integrations, and ongoing support for your enterprise.',
    icon: 'share-2',
    technologies: ['SharePoint Online', 'Power Platform', 'Power Automate', 'SPFx'],
    link: '/services#sharepoint',
  },
];

// Products Data
export const PRODUCTS = [
  {
    id: 'nok-spa',
    name: 'Nok Spa Management Suite',
    tagline: 'Complete spa management solution',
    description: 'Streamline your spa operations with our all-in-one management platform featuring booking, inventory, and customer management.',
    features: [
      'Online Booking System',
      'Customer Management',
      'Inventory Tracking',
      'Staff Scheduling',
      'Reporting & Analytics',
      'Payment Processing',
    ],
    pricing: [
      { tier: 'Starter', price: '$49/mo', features: ['Up to 100 bookings/mo', '2 staff accounts', 'Basic reports'] },
      { tier: 'Professional', price: '$99/mo', features: ['Unlimited bookings', '10 staff accounts', 'Advanced analytics', 'Priority support'] },
      { tier: 'Enterprise', price: 'Custom', features: ['Custom features', 'Unlimited everything', 'Dedicated support', 'On-premise option'] },
    ],
    link: '/products#nok-spa',
  },
  {
    id: 'sevenhc-pos',
    name: 'Nok POS',
    tagline: 'Modern point-of-sale system',
    description: 'Powerful yet easy-to-use POS system designed for retail and hospitality businesses of all sizes.',
    features: [
      'Touch-Screen Interface',
      'Inventory Management',
      'Sales Analytics',
      'Multi-Location Support',
      'Customer Loyalty Program',
      'Offline Mode',
    ],
    pricing: [
      { tier: 'Starter', price: '$79/mo', features: ['1 location', '1 register', 'Basic inventory', 'Email support'] },
      { tier: 'Professional', price: '$149/mo', features: ['3 locations', '5 registers', 'Advanced inventory', 'Priority support'] },
      { tier: 'Enterprise', price: 'Custom', features: ['Unlimited locations', 'Custom integrations', '24/7 support', 'Training included'] },
    ],
    link: '/products#sevenhc-pos',
  },
];

// Social Links
export const SOCIAL_LINKS = {
  linkedin: '#',
  twitter: '#',
  facebook: '#',
  instagram: '#',
};

// Navigation Links
export const NAV_LINKS = [
  { name: 'Services', path: '/services' },
  { name: 'Products', path: '/products' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact', cta: true },
];

// Footer Links
export const FOOTER_SECTIONS = [
  {
    title: 'Company',
    links: [
      { name: 'About Us', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Products', path: '/products' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { name: 'Custom Software', path: '/services#custom-software' },
      { name: 'Web Development', path: '/services#web-development' },
      { name: 'Data Analytics', path: '/services#data-analytics' },
      { name: 'SharePoint', path: '/services#sharepoint' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
    ],
  },
];

export default {
  COMPANY,
  SERVICES,
  PRODUCTS,
  SOCIAL_LINKS,
  NAV_LINKS,
  FOOTER_SECTIONS,
};
